import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const PageBuilderPage = lazy(() => import('./pages/PageBuilderPage'));
const SmartFormsPage = lazy(() => import('./pages/SmartFormsPage'));
const FormAnalyticsPage = lazy(() => import('./pages/FormAnalyticsPage'));
const PrefillFormsPage = lazy(() => import('./pages/PrefillFormsPage'));
const FormSubmissionsPage = lazy(() => import('./pages/FormSubmissionsPage'));

export const LandingRoutes: RouteObject = {
  path: 'landing',
  element: <ModuleGuard moduleId="marketing.landing" />,
  handle: { crumb: 'Landing Pages & Forms' },
  children: [
    { index: true, element: <Navigate to="page-builder" replace /> },
    { path: 'page-builder', element: <PageBuilderPage />, handle: { crumb: 'Page Builder' } },
    { path: 'smart-forms', element: <SmartFormsPage />, handle: { crumb: 'Smart Forms' } },
    { path: 'form-analytics', element: <FormAnalyticsPage />, handle: { crumb: 'Form Analytics' } },
    { path: 'prefill-forms', element: <PrefillFormsPage />, handle: { crumb: 'Prefill Forms' } },
    { path: 'form-submissions', element: <FormSubmissionsPage />, handle: { crumb: 'Form Submissions' } },
  ],
};
